// src/utils/toastHelpers.js
import toast from 'react-hot-toast';

export const success = (msg) => toast.success(msg, { duration: 4000 });
export const error   = (msg) => toast.error(msg, { duration: 6000 });
export const info    = (msg) => toast(msg, { icon: 'ℹ️' });
export const promise = (promiseFn, messages) => toast.promise(promiseFn, messages);